import QuillEditor from "@/components/ui/quille-editor/quill-editor";
import UserRepository from "@/utilities/repositories/Users";
import { useState } from "react";
import toast from "react-hot-toast";
import { Button, Modal } from "rizzui";

interface NoteModalProps {
  isOpen: boolean;
  onClose: () => void;
  userId: string;
  initialNote?: string;
  onSuccess: () => void;
}

export default function NoteModal({
  isOpen,
  onClose,
  userId,
  initialNote = "",
  onSuccess,
}: NoteModalProps) {
  const [note, setNote] = useState(initialNote);
  const [isLoading, setIsLoading] = useState(false);

  const handleSave = async () => {
    try {
      setIsLoading(true);
      await UserRepository.updateUser(userId, {
        note,
      });
      toast.success("Note updated successfully");
      onSuccess();
      onClose();
    } catch (error) {
      toast.error("Failed to update note");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="p-5">
        <h2 className="text-xl font-bold mb-4">Edit User Note</h2>
        <QuillEditor
          value={note}
          onChange={setNote}
          className="min-h-[300px] mb-4"
        />
        <div className="flex justify-end gap-3 mt-4">
          <Button variant="outline" onClick={onClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            onClick={handleSave}
            isLoading={isLoading}
            disabled={isLoading}
          >
            Save
          </Button>
        </div>
      </div>
    </Modal>
  );
}
